// import { CustomerSearchHistoryQuery } from "__generated__/api";
// import Items = CustomerSearchHistoryQuery.Items;
import { HistoryItem } from "../typings";

const buildDateKey = (hotel: HistoryItem) => `${hotel.startDate?.raw}-${hotel.endDate?.raw}`;

export const groupHotelsByDate = (recentlyViewedHotels: HistoryItem[]) =>
  recentlyViewedHotels
    .filter((item) => item !== null)
    .reduce(
      (acc, hotel) => ({
        ...acc,
        [buildDateKey(hotel)]: (acc[buildDateKey(hotel)] || []).concat(hotel),
      }),
      {}
    );
